const T_PREFIX = "contact-us";

export const contactUsTrns = {
  contactUsTitle: `${T_PREFIX}.contact-us-title`,
  contactUsIntro: `${T_PREFIX}.contact-us-intro`,
  sendRequestBtn: `${T_PREFIX}.send-request-btn`,
};

export const ourContactsTrns = {
  ourContactsTitle: `${T_PREFIX}.our-contacts-title`,
  ourContactsPhone: `${T_PREFIX}.our-contacts-phone`,
  ourContactsEmail: `${T_PREFIX}.our-contacts-email`,
  ourContactsAddress: `${T_PREFIX}.our-contacts-address`,
  ourContactsHours: `${T_PREFIX}.our-contacts-hours`,
};

export const contactUsRoleOptionsTrns = {
  agent: `${T_PREFIX}.options.agent-label`,
  owner: `${T_PREFIX}.options.owner-label`,
  other: `${T_PREFIX}.options.other-label`,
};
